/**
 * h5 cps渠道上报相关统一处理
 */

// cps上报路由
export const cpsRoute = ['hy.login'];

// cps三方库cdn地址
export const cpsCdnLink = {
  hy: 'https://h5pay.cmaom.com/JyChannelStatic/js/jychannel-cps.1.0.0.js',
};

export const insertLink = (src) => {
  let el = document.createElement('script');
  el.src = src;
  el.async = 'async';
  let s = document.getElementsByTagName('script')[0];
  s.parentNode.insertBefore(el, s);
};

export const cpsOnActive = {
  // 寰宇激活上报
  hy: (user) => {
    const { device_info, extra_data, app_name, game_version } = user;

    console.log('hy onActive', {
      deviceId: device_info.device_id,
      osType: 'ios',
      gameName: app_name || '黑暗光年',
      gameVersion: game_version,
    })
    window.JYProxySDK.onActive({
      ad: "1", 
      partnerId: "2", 
      sdkVersion: "1.0", 
      gameId: "368", 
      deviceId: device_info.device_id,
      osType: 'ios',
      gameName: app_name || '黑暗光年',
      gameVersion: game_version,
    });
  },
};

export const cpsLogin = {
  // 寰宇登录上报
  hy: (userId) => {
    console.log('hy onLogin', {
      userId
    })
    window.JYProxySDK.onLogin({ userId });
  },
};

export const cpsRegister = {
  // 寰宇注册上报
  hy: (userId) => {
    console.log('hy onReg', {
      userId
    })
    window.JYProxySDK.onReg({ userId });
  },
};

export const cpsPayOrder = {
  // 寰宇下单上报
  hy: (orderInfo, orderId) => {
    console.log('hy onPay', {
      productId: orderInfo.productId,
      productName: orderInfo.productName,
      productDesc: orderInfo.zfDesc,
      price: orderInfo.zfAmount,
      roleId: orderInfo.roleId,
      roleName: orderInfo.roleName,
      serverId: orderInfo.serverId,
      serverName: orderInfo.serverName,
      orderId: orderId,
    })
    window.JYProxySDK.onPay({
      productId: orderInfo.productId,
      productName: orderInfo.productName,
      productDesc: orderInfo.zfDesc,
      price: orderInfo.zfAmount,
      roleId: orderInfo.roleId,
      roleLevel: orderInfo.roleLevel,
      roleName: orderInfo.roleName,
      serverId: orderInfo.serverId,
      serverName: orderInfo.serverName,
      orderId: orderId,
    });
  },
};

export const cpsOrderCheck = {
  // 寰宇下单上报
  hy: (orderId) => {
    console.log('hy onOrderCheck', {
      orderId
    })
    window.JYProxySDK.onOrderCheck({ orderId });
  },
};
